import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const SLOW_EFFECTIVE_TYPES = new Set(['slow-2g', '2g'])
const TOAST_COOLDOWN_MS = 10 * 60 * 1000

const ConnectionStatus = () => {
  const lastToastAtRef = useRef(0)

  useEffect(() => {
    const connection = navigator.connection
      || navigator.mozConnection
      || navigator.webkitConnection
    if (!connection) return undefined

    const notifyIfSlow = () => {
      const isSlow = SLOW_EFFECTIVE_TYPES.has(connection.effectiveType)
        || connection.saveData
      if (!isSlow) return

      const now = Date.now()
      if (now - lastToastAtRef.current < TOAST_COOLDOWN_MS) return
      lastToastAtRef.current = now

      toast.error('Conexão Lenta', {
        position: 'top-left',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
      })
    }

    notifyIfSlow()
    connection.addEventListener('change', notifyIfSlow)
    return () => connection.removeEventListener('change', notifyIfSlow)
  }, [])

  return null
}

export default ConnectionStatus
